import { limitDecimal } from './limitDecimal';

export function calculateIMC(height: number, weight: number) {
  const imc = limitDecimal(weight / Math.pow(height, 2));
  return imc;
}
